/**
 * @description 环境权限管理 envauthority
 * @author xiehan
 * @date 2018/11/14
 */

import Logic from '../logic-base'

const envauthorityBiz = new Logic()

envauthorityBiz.findEnvAuthority = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.envauthority.findEnvAuthority,
    data: data
  })
}

envauthorityBiz.delete = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.envauthority.delete,
    data: data
  })
}

envauthorityBiz.save = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.envauthority.save,
    data: data
  })
}

envauthorityBiz.updateAuthority = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.envauthority.updateAuthority,
    data: data
  })
}

envauthorityBiz.findAuthorityById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.envauthority.findAuthorityById,
    data: data
  })
}

export default envauthorityBiz
